/* eslint-disable import/prefer-default-export */

export const GET_TRACKER_INFO = "GET_TRACKER_INFO";
export const GET_TRACKER_INFO_ERROR = "GET_TRACKER_INFO_ERROR";
